export default __webpack_public_path__ + "static/media/full-necromancer.8f41383c.jpg";